import { Link } from 'react-router-dom';
import { HiroMark } from '@/components/brand/HiroMark';
import { useLanguage } from '@/contexts/LanguageContext';
import { COOKIE_PREFERENCES_EVENT } from '@/lib/cookieConsent';

export function MarketingFooter() {
  const { t } = useLanguage();

  const openCookiePreferences = () => {
    window.dispatchEvent(new Event(COOKIE_PREFERENCES_EVENT));
  };

  return (
    <footer className="border-t border-border/60 bg-background py-10">
      <div className="container space-y-6">
        <div className="flex flex-col lg:flex-row justify-between gap-8 text-sm text-muted-foreground">
          <div className="space-y-2 max-w-md">
            <Link to="/" className="inline-flex items-center gap-2 text-foreground hover:opacity-90 transition-opacity w-fit">
              <HiroMark className="h-8 w-8 shrink-0" />
              <span className="font-display font-bold text-lg tracking-tight">HiroMatch</span>
            </Link>
            <p className="text-xs leading-relaxed">{t('marketing.footer.goneLegal')}</p>
            <p className="text-xs leading-relaxed">{t('marketing.footer.goneAddress')}</p>
            <p className="text-xs">{t('marketing.footer.goneVat')}</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-8">
            <div>
              <p className="text-xs font-medium text-foreground mb-2">{t('marketing.footer.legalGroup')}</p>
              <div className="flex flex-col gap-2">
                <Link to="/privacy" className="hover:text-foreground underline-offset-4 hover:underline">
                  {t('marketing.footer.privacy')}
                </Link>
                <Link to="/terms" className="hover:text-foreground underline-offset-4 hover:underline">
                  {t('marketing.footer.terms')}
                </Link>
                <Link to="/cookies" className="hover:text-foreground underline-offset-4 hover:underline">
                  {t('marketing.footer.cookies')}
                </Link>
                <Link to="/ai-transparency" className="hover:text-foreground underline-offset-4 hover:underline">
                  {t('marketing.footer.aiTransparency')}
                </Link>
                <button
                  type="button"
                  onClick={openCookiePreferences}
                  className="text-left hover:text-foreground underline-offset-4 hover:underline"
                >
                  {t('marketing.footer.cookiePreferences')}
                </button>
              </div>
            </div>
            <div>
              <p className="text-xs font-medium text-foreground mb-2">HiroMatch</p>
              <div className="flex flex-col gap-2">
                <Link to="/faq" className="hover:text-foreground underline-offset-4 hover:underline">
                  {t('marketing.nav.faq')}
                </Link>
                <Link to="/contact" className="hover:text-foreground underline-offset-4 hover:underline">
                  {t('marketing.footer.contact')}
                </Link>
                <Link to="/login" className="hover:text-foreground underline-offset-4 hover:underline">
                  {t('marketing.nav.login')}
                </Link>
              </div>
            </div>
          </div>
        </div>
        <p className="text-xs text-muted-foreground border-t border-border/40 pt-4">
          {t('marketing.footer.rights')}
        </p>
      </div>
    </footer>
  );
}
